import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { TelephoneNumberAdminComponent } from './telephone-number-admin.component';

const routes: Routes = [
  { path: '', component: TelephoneNumberAdminComponent, data: { title: 'Telephone Number Admin' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TelephoneNumberAdminRoutingModule {}

@NgModule({
  imports: [
    TelephoneNumberAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TelephoneNumberAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TelephoneNumberAdminModule {}
